module.exports = __webpack_public_path__ + "static/media/default_model.94380259.png";